module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dgc', [_c('div', {
    staticClass: "conteudo",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Sobre a DGC")]), _c('small', {
    staticClass: "more"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DGCSobre'
      }
    }
  }, [_vm._v("Ver tudo")])], 1)], 1), _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("A Diretoria de Contratos tem a finalidade de planejar,\nacompanhar a execução físico-financeira e coordenar a\nfiscalização administrativa dos contratos de obras e serviços de\nengenharia, cessão patrimonial e de serviços de natureza\ncontinuada, em consonância com as políticas e diretrizes de\ngovernança em contratações e aquisições regulamentadas pelo\nConselho de Administração da UFRN.")])])])], 1)]), _c('div', {
    staticClass: "row faixa legislacao"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-upper"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg"
  }, [_vm._v("  ")]), _vm._v("Legislação")])], 1), _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_c('strong', [_vm._v("LEI N° 8.666, DE 12 DE JUNHO DE 1993")]), _c('br'), _vm._v("Regulamenta o art. 37, inciso XXI, da Constituição Federal, institui normas para licitações e contratos da Administração Pública e dá outras providências.")])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f36fc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dgc/Index.vue
// module id = 448
// module chunks = 0